export const modifyArray = (arr = [], command = []) => {
  let newArr = [...arr];
  console.log('modifyArray: ', arr, command);
  command.map(({ index, ...value }) => {
    newArr[index] !== undefined ? (newArr[index] = { ...newArr[index], ...value }) : null;
  });
  return newArr;
};
